import { Component, Input } from '@angular/core';
import { IconType } from '@shared/utils/icons';
import { ButtonSize, ButtonType } from './button.properties';

@Component({
    selector: 'shared-ui-buttons-button-shared',
    template: '',
    standalone: false
})
export abstract class BaseButtonComponent {
  @Input() type: ButtonType = ButtonType.Default;
  @Input() size: ButtonSize = ButtonSize.Default;
  @Input() text = '';
  @Input() title = '';
  @Input() disabled = false;
  @Input() icon: IconType = IconType.None;
}
